import sha1 from "js-sha1";

export function previewFileByOW365(file) {
    window.open(process.env.OW365_URL + "&furl=" + process.env.PREVIEW_HOST + 'file/download?fileUrl=' + file.url + '&fileName=' + file.url);
}

export function _getFormatTimeStr(time) {
    let resultStr = '';

    let dayTime = 86400 * 1000;
    let hourTime = 3600 * 1000;
    let mineTime = 60 * 1000;

    let dayNum = 0;
    let hourNum = 0;
    let mineNum = 0;

    if (time > dayTime) {
        dayNum = (time - time % dayTime) / dayTime;
        time -= dayTime * dayNum;
        resultStr += dayNum + " 天 ";
    }

    if (time > hourTime) {
        hourNum = (time - time % hourTime) / hourTime;
        time -= hourTime * hourNum;
        resultStr += hourNum + " 小时 ";
    }

    if (time > mineTime) {
        mineNum = (time - time % mineTime) / mineTime;
        time -= mineTime * mineNum;
        resultStr += mineNum + " 分钟 ";
    }

    if (resultStr == '') {
        resultStr = (time - time % 1000) / 1000 + " 秒 ";
    }

    return resultStr;
}

export function genId() {
    return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    }).toUpperCase();
}

export function getWxSignature(jsapi_ticket, noncestr, timestamp, url) {
    var tmpStr = "jsapi_ticket=" + jsapi_ticket + "&noncestr=" + noncestr + "&timestamp=" + timestamp + "&url=" + url;

    return sha1(tmpStr);
}

/**
 * 是否android终端
 */
export function isAndroid() {
    var u = navigator.userAgent.toLowerCase();
    return u.indexOf('android') > -1;
}

/**
 * 是否ios终端
 */
export function isIOS() {
    var u = navigator.userAgent.toLowerCase();
    return /iphone|ipod|ipad/i.test(u);
}

/**
 * 判断是否企业微信客户端或者PC端打开
 */
export function isQiyeweixin() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("wxwork") > 0) {
        return true;
    } else {
        return false;
    }
}

/**
 * 判断是否企业微信客户端,包括Android和ios
 */
export function isQiyeweixinApp() {
    if (isQiyeweixin()) {
        if (isIOS() || isAndroid()) {
            return true;
        }
    }
    return false;
}

/** * 是否为windows系统 * */
export function isWindows() {
    return /windows|win32/i.test(navigator.userAgent);
}

/** * 是否为Mac系统 * */
export function isMac() {
    return /macintosh|mac os x/i.test(navigator.userAgent);
}

/**
 * 判断是否Mac企业微信客户端
 */
export function isMacQiyeweixin() {
    return isQiyeweixin() && isMac();
}

export function isIphoneX() {
    var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;

    return isIPhoneX;
}

export function isIPhoneXR() {
    var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;

    return isIPhoneXR;
}

export function isIPhoneXSMax() {
    var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;

    return isIPhoneXSMax;
}

export function convertCurrency(money) {
    if (!money) {
        return "";
    }
    var isNegative = false;
    money = money + '';
    if (money.indexOf("-") == 0) { //存在负数
        isNegative = true;
        money = money.replace("-", "");
    }
    var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); //汉字的数字
    var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
    var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
    var cnDecUnits = new Array("角", "分", "厘"); //对应小数部分单位
    var cnInteger = "整"; //整数金额时后面跟的字符
    var cnIntLast = "元"; //整型完以后的单位
    var maxNum = 999999999999999.9999; //最大处理的数字

    var IntegerNum; //金额整数部分
    var DecimalNum; //金额小数部分
    var ChineseStr = ""; //输出的中文金额字符串
    var parts; //分离金额后用的数组，预定义

    if (money == "") {
        return "";
    }

    money = parseFloat(money);
    if (money >= maxNum) {
        return "";
    }
    if (money == 0) {
        ChineseStr = cnNums[0] + cnIntLast + cnInteger;
        return ChineseStr;
    }
    money = money.toString(); //转换为字符串
    if (money.indexOf(".") == -1) {
        IntegerNum = money;
        DecimalNum = '';
    } else {
        parts = money.split(".");
        IntegerNum = parts[0];
        DecimalNum = parts[1].substr(0, 3);
    }
    if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
        var zeroCount = 0;
        var IntLen = IntegerNum.length;
        for (var i = 0; i < IntLen; i++) {
            var n = IntegerNum.substr(i, 1);
            var p = IntLen - i - 1;
            var q = p / 4;
            var m = p % 4;
            if (n == "0") {
                zeroCount++;
            } else {
                if (zeroCount > 0) {
                    ChineseStr += cnNums[0];
                }
                zeroCount = 0; //归零
                ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
            }
            if (m == 0 && zeroCount < 4) {
                ChineseStr += cnIntUnits[q];
            }
        }
        ChineseStr += cnIntLast;
        //整型部分处理完毕
    }
    if (DecimalNum != '') { //小数部分
        var decLen = DecimalNum.length;
        for (var i = 0; i < decLen; i++) {
            var n = DecimalNum.substr(i, 1);
            if (n != '0') {
                ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
            }
            if (i == '0' && n == '0') {
                ChineseStr += '零'
            } else if (i == 1 && n == '0' && DecimalNum.substr(0, 1) != 0) {
                ChineseStr += '零'
            }
        }
    }
    if (ChineseStr == '') {
        ChineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (DecimalNum == '') {
        ChineseStr += cnInteger;
    }
    if (isNegative) {
        ChineseStr = "负" + ChineseStr;
    }
    return ChineseStr;
}

export function getFirstWord(invoiceInfo = {}, key, defaultVal = '') {
  const arr = invoiceInfo[key];
  if (!Array.isArray(arr) || arr.length === 0) return defaultVal;
  const v = arr[0];
  if (v && typeof v.word === 'string') return v.word;
  return defaultVal;
}

// 如果有可能需要按 row 合并多行字段
export function getAllWordsJoined(invoiceInfo = {}, key, separator = '，') {
  const arr = invoiceInfo[key];
  if (!Array.isArray(arr) || arr.length === 0) return '';
  return arr.map(item => item.word).filter(Boolean).join(separator);
}
